var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6125 0C11.4487 0 11.2916 0.0650918 11.1758 0.18092L10.0713 1.28535C9.68079 1.67587 9.68078 2.30904 10.0713 2.69957L15.0309 7.65918C15.4214 8.0497 16.0546 8.0497 16.4451 7.65918L17.5496 6.55475C17.7908 6.31353 17.7908 5.92245 17.5496 5.68124L12.0493 0.18092C11.9335 0.0650918 11.7764 0 11.6125 0ZM13.289 9.07918C13.6795 8.68865 13.6795 8.05549 13.289 7.66496L10.0661 4.44208C9.67558 4.05156 9.04242 4.05156 8.65189 4.44208L4.4414 8.65257C4.05087 9.0431 4.05087 9.67626 4.4414 10.0668L7.66428 13.2897C8.05481 13.6802 8.68797 13.6802 9.0785 13.2897L13.289 9.07918ZM20.4506 17.7937L14.093 11.4361C13.7024 11.0456 13.0693 11.0456 12.6788 11.4361L11.4359 12.6789C11.0454 13.0695 11.0454 13.7026 11.4359 14.0932L17.7936 20.4508C18.1598 20.8171 18.641 21.0002 19.1221 21.0002C19.6032 21.0002 20.0843 20.8171 20.4506 20.4508C21.1831 19.7182 21.1831 18.5263 20.4506 17.7937ZM0.181862 11.1758L1.28625 10.0714C1.67677 9.68085 2.30995 9.68085 2.70047 10.0714L7.66008 15.031C8.0506 15.4215 8.0506 16.0547 7.66008 16.4452L6.55561 17.5497C6.43498 17.6703 6.27691 17.7305 6.11887 17.7305C5.96084 17.7305 5.80273 17.6702 5.68214 17.5496L0.181862 12.0493C-0.059351 11.8081 -0.059351 11.417 0.181862 11.1758Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGame);
export default __webpack_public_path__ + "static/media/menu-game.7da84a6c7b106956d39fc5cad7eee2cb.svg";
export { ForwardRef as ReactComponent };